import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

function selectInputText(element) {
    element.setSelectionRange(0, element.value.length);
}

export default class TextEdit extends React.Component {
    static propTypes = {
        text: PropTypes.string,
        paramName: PropTypes.string,
        change: PropTypes.func,
        placeholder: PropTypes.string,
        className: PropTypes.string,
        activeClassName: PropTypes.string,
        minLength: PropTypes.number,
        maxLength: PropTypes.number,
        validate: PropTypes.func,
        style: PropTypes.object,
        editingElement: PropTypes.string,
        staticElement: PropTypes.string,
        tabIndex: PropTypes.number,
        isDisabled: PropTypes.bool,
        element: PropTypes.string,
        staticStateClick: PropTypes.func,
        id: PropTypes.string,
        onblur: PropTypes.func,
        stopPropagation: PropTypes.bool,
        staticMouseover: PropTypes.func,
        staticMouseleave: PropTypes.func
    };

    static defaultProps = {
        minLength: 1,
        maxLength: 256,
        editingElement: 'input',
        staticElement: 'span',
        tabIndex: 0,
        isDisabled: false
    };

    state = {
        editing: false,
        text: this.props.text,
        minLength: this.props.minLength,
        maxLength: this.props.maxLength,
    };

    componentWillMount() {
        this.isInputValid = this.props.validate || this.isInputValid;
        // Warn about deprecated elements
        if (this.props.element) {
            console.warn('`element` prop is deprecated: instead pass editingElement or staticElement to TextEdit component');
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.text !== this.props.text) {
            this.setState({ text: nextProps.text });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const inputElem = ReactDOM.findDOMNode(this.refs.input);
        if (this.state.editing && !prevState.editing) {
            inputElem.focus();
            selectInputText(inputElem);
        } else if (this.state.editing && prevProps.text !== this.props.text) {
            this.finishEditing();
        }
    }

    startEditing = (e) => {
        if (this.props.stopPropagation) {
            e.stopPropagation();
        }
        this.setState({editing: true, text: this.props.text});
        this.props.staticStateClick(this.state.text);
    };

    finishEditing = () => {
        if (this.isInputValid(this.state.text) && this.props.text !== this.state.text) {
            this.commitEditing();
        } else if (this.props.text === this.state.text || !this.isInputValid(this.state.text)) {
            this.cancelEditing();
        }
        this.props.onblur();
    };

    cancelEditing = () => {
        this.setState({editing: false, text: this.props.text});
    };

    commitEditing = () => {
        this.setState({editing: false, text: this.state.text});
        const newProp = {};
        newProp[this.props.paramName] = this.state.text;
        this.props.change(newProp);
    };

    clickWhenEditing = (e) => {
        if (this.props.stopPropagation) {
            e.stopPropagation();
        }
    };

    isInputValid = (text) => {
        return (text.length >= this.state.minLength && text.length <= this.state.maxLength);
    };

    keyUp = (event) => {
        if (event.keyCode === 13 && this.props.editingElement !== 'textArea') {
            this.finishEditing();
        } else if (event.keyCode === 27) {
            this.cancelEditing();
        } else {
            this.isInputValid(this.state.text);
        }
    };

    textChanged = (event) => {
        this.setState({
            text: event.target.value.trim()
        });
    };

    render() {
        if (this.props.isDisabled) {
            const Element = this.props.element || this.props.staticElement;
            return (<Element
              className={this.props.className}
              style={this.props.style}
              id={this.props.id}
            >
              {this.state.text || this.props.placeholder}
            </Element>);
        } else if (!this.state.editing) {
            const Element = this.props.element || this.props.staticElement;
            return (<Element
              className={this.props.className}
              onClick={this.startEditing}
              tabIndex={this.props.tabIndex}
              style={this.props.style}
              id={this.props.id}
              onMouseEnter={this.props.staticMouseover}
              onMouseLeave={this.props.staticMouseleave}
            >
                {this.state.text || this.props.placeholder}
            </Element>);
        }
        const Element = this.props.element || this.props.editingElement;
        return (<Element
          onClick={this.clickWhenEditing}
          onKeyUp={this.keyUp}
          onBlur={this.finishEditing}
          className={this.props.activeClassName}
          placeholder={this.props.placeholder}
          defaultValue={this.state.text}
          onReturn={this.finishEditing}
          onChange={this.textChanged}
          style={this.props.style}
          ref="input"
          id={this.props.id}
          maxLength={this.props.maxLength}
        />);
    }
}



// WEBPACK FOOTER //
// ./src/components/SharedComponents/Inline/text-edit.js